import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialYoutube = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M21.582 8.03c-.23-.8-.907-1.428-1.768-1.642C18.254 6 12 6 12 6s-6.255 0-7.814.388c-.86.214-1.537.843-1.768 1.642C2 9.478 2 12.5 2 12.5s0 3.022.418 4.47c.23.8.907 1.428 1.768 1.642C5.746 19 12 19 12 19s6.255 0 7.814-.388c.86-.214 1.537-.843 1.768-1.642C22 15.522 22 12.5 22 12.5s-.002-3.022-.418-4.47ZM9.998 15.286l5.196-2.786-5.196-2.785z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialYoutube) as SvgIcon;
export { ForwardRef as ReactComponent };
